export const CHANGE_USERINFO = 'change_userInfo';
export const CHANGE_USERSETTING = 'change_userSetting';
export const CHANGE_PERMISSION_MENUS = 'change_permissionMenus';
export const CHANGE_PERMISSION_BUTTONS = 'change_permissionButtons';
export const CHANGE_CACHE_ROUTERS = 'change_cacheRouters';
export const CHANGE_NAV_SETTING = 'change_navSetting';
export const CHANGE_PREVIOUS_ROUTE = 'change_previousRoute';

